module.exports = __webpack_public_path__ + "img/plan-b-info-title-mobile.72e096f9.png";